import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { EnvService } from 'src/app/env.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  isLoading = false;
  isOtpSent = false;
  email="";
  otp="";
  private authStatusSub: Subscription;
  constructor(public authService: AuthService, private http: HttpClient, private router: Router, private env: EnvService, private _snackBar: MatSnackBar) { }

  @ViewChild('container') container: ElementRef;



  ngOnInit() {
    this.authStatusSub = this.authService.getAuthStatusListener().subscribe(
      authStatus => {
        this.isLoading = false;
        if(authStatus.state == "otp" && authStatus.success){
          this.isOtpSent = true;
        }
      }
    );
    if(localStorage.getItem("token")) {
      this.router.navigate(['home'])
    }
  }

  toggleSignIn() {
    this.container.nativeElement.classList.remove('right-panel-active');
  }

  toggleSignUp() {
    this.container.nativeElement.classList.add('right-panel-active');
  }


  onLogin(form: NgForm) {
    console.log(form.value);
    if (form.invalid) return;
    this.isLoading = true;
    if(this.isOtpSent){
      if(this.otp == "" || this.email == ""){
        return;
      }
      this.authService.verifyOtp(this.email,this.otp);
    }else {
      this.email = form.value.email;
      this.authService.login(form.value.email, form.value.password);
    }
  }

  openSnackBar(msg) {
    this._snackBar.open(msg, '', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  forgotPassword() {
    var response = prompt("Please enter your emailId for changing password:");
    console.log(response);
    this.http.post(this.env.apiUrl + "/api/user/forgotPassword", {email: response})
    .subscribe(response => {
      console.log(response);
      this.openSnackBar("Link sent to your emailId for changing password");
      setTimeout(() => {
        this.router.navigate(['login']);
      }, 2000);
    }, err => {
      console.log(err);
    })
  }

  ngOnDestroy() {
    this.authStatusSub.unsubscribe();
  }

}
